export default __webpack_public_path__ + "static/media/number1.13f975a4.svg";